import { useCallback } from 'react';
import { prefixLogger } from '../logger';
const logDebug = prefixLogger('useGatekeeper').debug;
const logError = prefixLogger('useGatekeeper').error;
const useGatekeeper = ({ wallet, stage, gatekeeperClient, }, state, dispatch) => {
    const { ownerSigns } = state;
    /**
     * if a request is not already in progress, initiate a request to the gatekeeper for a new token
     * and dispatch an event so we know it's in progress
     */
    const waitForGatekeeperIssuanceRequest = useCallback(
    // eslint-disable-next-line @typescript-eslint/no-shadow
    async ({ payload, proof, abortController, }) => {
        if (!wallet || !wallet.publicKey || !gatekeeperClient) {
            return;
        }
        logDebug('waitForGatekeeperIssuanceRequest ready to call requestGatewayTokenFromGatekeeper', {
            payload,
        });
        dispatch({ type: 'requestGatekeeperIssuance' });
        const requestGatewayTokenFromGatekeeperResult = await gatekeeperClient.requestGatewayTokenFromGatekeeper({
            wallet,
            payload,
            proof,
            ownerSigns: ownerSigns !== null && ownerSigns !== void 0 ? ownerSigns : false,
        });
        logDebug('requestGatewayTokenFromGatekeeperResult', {
            requestGatewayTokenFromGatekeeperResult,
            isAborted: abortController === null || abortController === void 0 ? void 0 : abortController.signal.aborted,
        });
        if (abortController === null || abortController === void 0 ? void 0 : abortController.signal.aborted) {
            return;
        }
        if (!requestGatewayTokenFromGatekeeperResult || requestGatewayTokenFromGatekeeperResult.status >= 500) {
            logError('Error requesting token from gatekeeper');
            dispatch({ type: 'requestGatekeeperIssuanceFailed' });
            dispatch({ type: 'civicPass_issuance_failure' });
            return;
        }
        if (requestGatewayTokenFromGatekeeperResult.status >= 400) {
            logError('Token rejected by gatekeeper');
            dispatch({ type: 'requestGatekeeperIssuanceRejected' });
            dispatch({ type: 'civicPass_issuance_rejected' });
            return;
        }
        const { pending } = requestGatewayTokenFromGatekeeperResult;
        if (pending) {
            dispatch({ type: 'requestGatekeeperIssuanceInReview', pending });
            return;
        }
        const { transaction } = requestGatewayTokenFromGatekeeperResult;
        logDebug('Successfully requested gatekeeper token, setting gatewayTokenTransaction and dispatching requestGatekeeperIssuanceComplete', { transaction });
        dispatch({ type: 'requestGatekeeperIssuanceComplete', gatewayTokenTransaction: transaction });
    }, [gatekeeperClient, wallet, stage, ownerSigns]);
    return {
        waitForGatekeeperIssuanceRequest,
        gatekeeperClient,
    };
};
export default useGatekeeper;
